export function terms(left, right) {
  return left && left.equals(right);
}
export function resources(compareGraph) {
  return (left, right) => {
    if (!left || !right) {
      return false;
    }

    const idsEqual = left.id.equals(right.id);

    if (!compareGraph) {
      return idsEqual;
    }

    return idsEqual && left._graphId.equals(right._graphId);
  };
}